import { render, staticRenderFns } from "./AverageWeightChart.vue?vue&type=template&id=dc9408f2"
import script from "./AverageWeightChart.vue?vue&type=script&lang=js"
export * from "./AverageWeightChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports